import { useEffect, useState, useContext } from "react";
import { Navigate } from "react-router-dom";
import RouteWrapper from "./RouteWrapper";
import { getToken } from "../utils/auth";
import { validate } from "../api/app/authRequests";
import LoadingWrapper from "../components/LoadingWrapper"
import Context from "../context/Context";

const ProtectedRoute = () => {
    const [isValid, setIsValid] = useState(null);

    const { showSnackbar } = useContext(Context)

    const token = getToken();

    useEffect(() => {

        if (!token) {
            setIsValid(false);
            return;
        }

        validate()
            .then((res) => setIsValid(res.valid))
            .catch((e) => {
                showSnackbar(e.message, 'warning');
                setIsValid(false)
            })
    }, [token]);

    if (isValid === null) return (
        <div
            style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                minHeight: "100vh"
            }}>
            <LoadingWrapper isLoading={isValid === null}>
            </LoadingWrapper>
        </div>
    );

    if (!isValid) return <Navigate to="/invite" replace />;

    return <RouteWrapper />;
};

export default ProtectedRoute;
